import { makeEnumClass } from '../base-enum';

export class EnumPerfil extends makeEnumClass() {
    static readonly FERIAS_ADM = EnumPerfil.add('FERIAS_ADM', 'FERIAS_ADM');
    static readonly FERIAS_GESTOR = EnumPerfil.add('FERIAS_GESTOR', 'FERIAS_GESTOR');
    static readonly FERIAS_OPERACIONAL = EnumPerfil.add('FERIAS_OPERACIONAL', 'FERIAS_OPERACIONAL');
    static readonly FERIAS_CONSULTA_RH = EnumPerfil.add('FERIAS_CONSULTA_RH', 'FERIAS_CONSULTA_RH');
}
